var map = {
	"./addAbility.json": "./src/locales/zh_CN/addAbility.json",
	"./apiManage.json": "./src/locales/zh_CN/apiManage.json",
	"./appCapabilitiesAddPush.json": "./src/locales/zh_CN/appCapabilitiesAddPush.json",
	"./appCapabilitiesEdit.json": "./src/locales/zh_CN/appCapabilitiesEdit.json",
	"./appCapabilitiesList.json": "./src/locales/zh_CN/appCapabilitiesList.json",
	"./appCapabilitiesWecode.json": "./src/locales/zh_CN/appCapabilitiesWecode.json",
	"./approve.json": "./src/locales/zh_CN/approve.json",
	"./baseInfo.json": "./src/locales/zh_CN/baseInfo.json",
	"./capabilityManage.json": "./src/locales/zh_CN/capabilityManage.json",
	"./common.json": "./src/locales/zh_CN/common.json",
	"./complaintDetail.json": "./src/locales/zh_CN/complaintDetail.json",
	"./complaintManage.json": "./src/locales/zh_CN/complaintManage.json",
	"./entryGroupNotification.json": "./src/locales/zh_CN/entryGroupNotification.json",
	"./eventCallback.json": "./src/locales/zh_CN/eventCallback.json",
	"./home.json": "./src/locales/zh_CN/home.json",
	"./memberManage.json": "./src/locales/zh_CN/memberManage.json",
	"./operationManagement.json": "./src/locales/zh_CN/operationManagement.json",
	"./projectConfiguration.json": "./src/locales/zh_CN/projectConfiguration.json",
	"./version.json": "./src/locales/zh_CN/version.json",
	"./weform.json": "./src/locales/zh_CN/weform.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales/zh_CN sync recursive \\.json$";